<template>
  <label
    class="checkbox"
    :class="{
      'checkbox--disabled': disabled,
      'checkbox--switch': isSwitch(),
      'checkbox--error': error
    }"
    :for="`checkbox-${name}-${checkboxValue}`"
    @click="toggle"
  >
    <span
      class="checkbox__wrapper"
    >
      <input
        type="checkbox"
        class="checkbox__input"
        :class="{
          'checkbox__input--disabled': disabled
        }"
        required="required"
        :name="name"
        :checked="modelValue"
        :value="modelValue ? checkboxValue : ''"
        :disabled="disabled"
      >
      <span
        class="checkbox__label"
        :class="{
          'checkbox__label--disabled': disabled
        }"
        v-html="label"
      />
      <info-popup
        class="radio-input__info"
        v-if="infoText"
        :show-close-icon="true"
        position="bottom-right"
      >
        {{ infoText }}
      </info-popup>
    </span>
    <transition name="input-error--animation">
      <span
        v-if="error"
        class="checkbox__error | input-error"
      >
        {{ error }}
      </span>
    </transition>
  </label>
</template>

<script>
  import InfoPopup from '../infoPopup/infoPopup';
  import diContainer from '../../utilities/js/diContainer/diContainer';

  const Checkbox = {
    name: 'checkbox',
    components: {InfoPopup},
    props: {
      name: {
        type: String,
        default() {
          return '';
        }
      },
      disabled: {
        type: Boolean,
        default: false
      },
      label: String,
      error: String,
      infoText: String,
      checkboxValue: String,
      modelValue: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        settings: diContainer.get('formSettings'),
      }
    },
    methods: {
      toggle(event) {
        const isLink = (event.target && event.target.tagName && event.target.tagName.toLowerCase() === 'a');
        if (!this.disabled && !isLink) {
          this.$emit('update:modelValue', !this.modelValue);
          this.$emit('input', !this.modelValue);
          this.$emit('change', {
            value: !this.value,
            srcEvent: event
          });
        }
      },
      isSwitch() {
        return this.settings.checkboxIsSwitch;
      }
    }
  };

  export default Checkbox;
</script>
